import { render, staticRenderFns } from "./SiteInstall.vue?vue&type=template&id=7672f236&scoped=true"
import script from "./SiteInstall.vue?vue&type=script&lang=js"
export * from "./SiteInstall.vue?vue&type=script&lang=js"
import style0 from "./SiteInstall.vue?vue&type=style&index=0&id=7672f236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7672f236",
  null
  
)

export default component.exports